import React from 'react';
import { QuoteIcon, StarIcon } from 'lucide-react';
import { SectionHeader } from '../ui/SectionHeader';
import { Reveal } from '../ui/Reveal';
import { testimonials, type Testimonial } from '../../data/services';
function Stars() {
  return <div className="flex gap-0.5" aria-label="5 de 5 estrellas" data-id="element-235" data-mp="3mfhg84kwlvhq">
      {Array.from({
      length: 5
    }).map((_, s) => <StarIcon key={s} size={13} className="fill-gold text-gold" data-id="element-236" data-mp="3r9ll8ialztg6" data-mpi={s} />)}
    </div>;
}
function Caption({
  t
}: {
  t: Testimonial;
}) {
  return <figcaption className="mt-7 flex items-center gap-3 border-t border-navy/[0.07] pt-5" data-id="element-237" data-mp="41rq52da9x4o">
      <span className="flex h-9 w-9 items-center justify-center rounded-full bg-sage/25 font-display text-[11px] font-semibold text-teal" data-id="element-238" data-mp="91mizbgmcwsd">
        {t.initials}
      </span>
      <span className="text-[13px] font-medium text-navy/75" data-id="element-239" data-mp="2at92yt23frfc">— {t.name}</span>
    </figcaption>;
}
export function Testimonials() {
  const [featured, ...rest] = testimonials;
  return <section id="testimonios" className="bg-white py-20 lg:py-32" data-id="element-240" data-mp="2fu6ptiy1t9n6">
      <div className="mx-auto max-w-shell px-5 lg:px-10" data-id="element-241" data-mp="1sm3wpw8h68g6">
        <SectionHeader eyebrow="Lo que dicen mis clientes" title="Experiencias que hablan por sí mismas." data-id="element-242" data-mp="1ntasraktz455" />

        <ul className="no-scrollbar mt-14 flex snap-x snap-mandatory gap-5 overflow-x-auto pb-2 lg:grid lg:grid-cols-4 lg:overflow-visible" data-id="element-243" data-mp="1iv98wnfkz0sm">
          <li className="w-[86%] shrink-0 snap-start sm:w-[60%] lg:col-span-2 lg:w-auto" data-id="element-244" data-mp="2bjezhqtbfk0d">
            <Reveal className="h-full" data-id="element-245" data-mp="26kaocumtzc7e">
              <figure className="flex h-full flex-col gap-6 rounded-[24px] border border-navy/[0.08] bg-cream p-7 sm:flex-row" data-id="element-246" data-mp="26lddax0lf4ko">
                <img src={featured.image} alt={featured.imageAlt} className="max-h-[420px] w-full shrink-0 self-start rounded-[16px] border border-navy/[0.08] object-cover object-top sm:w-[44%] lg:max-h-[520px]" loading="lazy" data-id="element-247" data-mp="22gvvv4hph3d2" />
                <div className="flex flex-1 flex-col" data-id="element-248" data-mp="m6tkiuo7ixh3">
                  <QuoteIcon size={26} strokeWidth={1.25} className="text-gold/70" aria-hidden="true" data-id="element-249" data-mp="nmnvs9uinm8n" />
                  <div className="mt-5" data-id="element-250" data-mp="sjeaasqoa9ry">
                    <Stars data-id="element-251" data-mp="sicwigi9v96j" />
                  </div>
                  <blockquote className="mt-4 flex-1 text-[15px] font-light leading-relaxed text-ink/75" data-id="element-252" data-mp="ejwis5lzsiew">
                    “{featured.quote}”
                  </blockquote>
                  <Caption t={featured} data-id="element-253" data-mp="4ummedk48dkz" />
                </div>
              </figure>
            </Reveal>
          </li>

          {rest.map((t, i) => <li key={i} className="w-[82%] shrink-0 snap-start sm:w-[45%] lg:w-auto" data-id="element-254" data-mp="9nxxiqvyngip" data-mpi={i}>
              <Reveal delay={(i + 1) * 0.06} className="h-full" data-id="element-255" data-mp="3r3xkw8rhitpy">
                <figure className="flex h-full flex-col rounded-[24px] border border-navy/[0.08] bg-cream p-7" data-id="element-256" data-mp="3w0o4v76eu9gn">
                  <QuoteIcon size={26} strokeWidth={1.25} className="text-gold/70" aria-hidden="true" data-id="element-257" data-mp="3i2ptmandyt5d" />
                  <div className="mt-5" data-id="element-258" data-mp="3mzg6kp3w98mk">
                    <Stars data-id="element-259" data-mp="3n2kgm341iyl5" />
                  </div>
                  <blockquote className="mt-4 flex-1 text-[14.5px] font-light leading-relaxed text-ink/70" data-id="element-260" data-mp="33fr10ccslsp2">
                    “{t.quote}”
                  </blockquote>
                  <Caption t={t} data-id="element-261" data-mp="3cg5p1jh55lw9" />
                </figure>
              </Reveal>
            </li>)}
        </ul>
      </div>
    </section>;
}